import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { GameProviderEntityService } from '@views/pages/apps/games/game-providers/services/game-provider-entity.service';

@Injectable()
export class GameProviderResolver implements Resolve<boolean> {

    constructor(private gameProviderEntityService: GameProviderEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.gameProviderEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.gameProviderEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
